import { FC, ReactNode } from 'react';

interface TooltipProps {
  content: ReactNode;
  children: ReactNode;
  position?: 'top' | 'bottom' | 'left' | 'right';
}

const Tooltip: FC<TooltipProps> = ({ content, children, position = 'top' }) => {
  const getPositionClasses = () => {
    switch (position) {
      case 'top':
        return 'bottom-full left-1/2 -translate-x-1/2 mb-2';
      case 'bottom':
        return 'top-full left-1/2 -translate-x-1/2 mt-2';
      case 'left':
        return 'right-full top-1/2 -translate-y-1/2 mr-2';
      case 'right':
        return 'left-full top-1/2 -translate-y-1/2 ml-2';
      default:
        return 'bottom-full left-1/2 -translate-x-1/2 mb-2';
    }
  };

  return (
    <div className="relative group inline-block">
      {children}
      <div
        className={`absolute ${getPositionClasses()} 
        bg-gray-900 text-white text-sm py-1 px-2 rounded opacity-0 
        group-hover:opacity-100 transition-opacity duration-200 
        whitespace-nowrap z-50 pointer-events-none`}
      >
        {content}
        <div
          className={`absolute ${
            position === 'top'
              ? 'bottom-[-6px] border-t-gray-900'
              : position === 'bottom'
              ? 'top-[-6px] border-b-gray-900'
              : position === 'left'
              ? 'right-[-6px] border-l-gray-900'
              : 'left-[-6px] border-r-gray-900'
          } ${
            position === 'top' || position === 'bottom'
              ? 'left-1/2 -translate-x-1/2 border-x-transparent border-x-[6px]'
              : 'top-1/2 -translate-y-1/2 border-y-transparent border-y-[6px]'
          } border-[6px]`}
        />
      </div>
    </div>
  );
};

export default Tooltip; 